import { createStore, combineReducers } from "redux";
import firebase from "firebase/app";
// import 'firebase/auth'
import "firebase/firestore"; // <- needed if using firestore
// import "firebase/analytics";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from 'redux-firestore' // <- needed if using firestore


import mainReducer from "./reducers/mainReducer";
import rundownReducer from "./reducers/rundownReducer";
import runtimeReducer from "./reducers/runtimeReducer";

const firebaseConfig = {
	apiKey: "AIzaSyCARPbzyft-siO0t3sDnsb9kwf6KD5Owj8",
	authDomain: "h2r-graphics-9fb77.firebaseapp.com",
	projectId: "h2r-graphics-9fb77",
	storageBucket: "h2r-graphics-9fb77.appspot.com",
	messagingSenderId: "68061119853",
	appId: "1:68061119853:web:0c2ce685989403e416c664",
	measurementId: "G-61BX9RPHNN",
};

export const fb = firebase.initializeApp(firebaseConfig);
firebase.firestore(); // <- needed if using firestore
// firebase.analytics();

const rootReducer = combineReducers({
	main: mainReducer,
	rundown: rundownReducer,
	firebase: firebaseReducer,
	runtime: runtimeReducer,
	firestore: firestoreReducer,
});

// Create store with reducers and initial state
const initialState = {};

const store = createStore(
	rootReducer,
	initialState,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
